module.exports = "https://cdn-challenge.mathletics.com/app/280/assets/images/01888f59e4ca633e47a4b51ddae9ced7.svg";